module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-light/MiloOffc-Light.ttf
// module id = 515
// module chunks = 0